import { useCallback, useMemo } from "react";

import { useSavedFilters } from "@/ds";
import type { FilterValue } from "@/ds";
import { getPersistedUser } from "@/modules/auth";

/** Filtros salvos da tela, só no navegador, por usuário logado e por tela (`screen` é a chave de armazenamento). */
export function useSessionSavedFilters(screen: string) {
  const sessionUser = useMemo(() => getPersistedUser(), []);
  const { savedFilters, saveFilter, deleteFilter } = useSavedFilters({
    screen,
    userId: sessionUser?.email ?? sessionUser?.sub ?? sessionUser?.preferredUsername,
  });

  /** Acha o filtro salvo e entrega o conjunto a `apply`, que é o que muda de tela para tela. */
  const applySavedFilter = useCallback(
    (id: string, apply: (value: FilterValue) => void) => {
      const saved = savedFilters.find((item) => item.id === id);
      if (saved) apply(saved.value);
    },
    [savedFilters],
  );

  return { savedFilters, saveFilter, deleteFilter, applySavedFilter };
}
